// eslint-disable-next-line import/prefer-default-export
export const ACTIONS = {
  REQUEST_STACKABLE_SAVINGS: 'REQUEST_STACKABLE_SAVINGS',
  RECEIVE_STACKABLE_SAVINGS: 'RECEIVE_STACKABLE_SAVINGS',
  REQUEST_STACKABLE_SAVINGS_ERROR: 'REQUEST_STACKABLE_SAVINGS_ERROR',
};
